import classnames from 'classnames'
import React, { ReactNode } from 'react'

interface ILabelProps {
  label: string
  children: ReactNode
  isNarrow?: boolean
}

export const Label = (props: ILabelProps) => {
  const labelClassName = classnames({
    'def-lst__narrow': props.isNarrow,
  })

  return (
    <>
      <dt className={labelClassName}>{props.label}</dt>
      <dd>{props.children}</dd>
    </>
  )
}
